import React, { memo } from 'react';
import * as PropTypes from 'prop-types';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';

function ClientsEventSelectWithoutQuery({ clientsEvents, clientGid, label, name, formInputChanged, value, ...remainingProps }) {
  const { makeStyles, SelectMui } = useUiContext();

  const useMenuStyles = makeStyles({
    menuPaper: {
      maxHeight: 175,
    },
  });
  const menuClasses = useMenuStyles();

  const options = clientsEvents.map((ce) => ({ value: ce.id, label: `${ce.eventDate}${ce.eventTitle ? ` : ${ce.eventTitle}` : ''}` }));

  return (
    <SelectMui
      id="clients_event_select"
      label={label}
      name={name}
      options={options}
      onChange={formInputChanged}
      value={value}
      MenuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        getContentAnchorEl: null,
        classes: { paper: menuClasses.menuPaper },
      }}
      {...remainingProps}
    />
  );
}

ClientsEventSelectWithoutQuery.defaultProps = {
  addNewOption: false,
};
ClientsEventSelectWithoutQuery.propTypes = {
  addNewOption: PropTypes.bool,
  clientGid: PropTypes.string.isRequired,
  clientsEvents: PropTypes.arrayOf(PropTypes.object).isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  formInputChanged: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default memo(ClientsEventSelectWithoutQuery);
